// source: type/custom_field_option.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_descriptor_pb = require('google-protobuf/google/protobuf/descriptor_pb.js');
goog.object.extend(proto, google_protobuf_descriptor_pb);
goog.exportSymbol('proto.type.SensitiveData', null, global);
goog.exportSymbol('proto.type.SensitiveData.SensitiveDataType', null, global);
goog.exportSymbol('proto.type.sensitiveData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.SensitiveData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.SensitiveData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.SensitiveData.displayName = 'proto.type.SensitiveData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.SensitiveData.prototype.toObject = function(opt_includeInstance) {
  return proto.type.SensitiveData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.SensitiveData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.SensitiveData.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SensitiveData as accepted by the `fromObject` method.
 * @record
 */
proto.type.SensitiveData.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.dataType;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.SensitiveData.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.SensitiveData}
 */
proto.type.SensitiveData.fromObject = function(obj) {
  var msg = new proto.type.SensitiveData();
  obj.dataType != null && jspb.Message.setField(msg, 1, obj.dataType);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.SensitiveData}
 */
proto.type.SensitiveData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.SensitiveData;
  return proto.type.SensitiveData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.SensitiveData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.SensitiveData}
 */
proto.type.SensitiveData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.type.SensitiveData.SensitiveDataType} */ (reader.readEnum());
      msg.setDataType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.SensitiveData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.SensitiveData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.SensitiveData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.SensitiveData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.type.SensitiveData.SensitiveDataType = {
  UNSPECIFIED: 0,
  SECRET: 1,
  PII: 2
};

/**
 * optional SensitiveDataType data_type = 1;
 * @return {!proto.type.SensitiveData.SensitiveDataType}
 */
proto.type.SensitiveData.prototype.getDataType = function() {
  return /** @type {!proto.type.SensitiveData.SensitiveDataType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.type.SensitiveData.SensitiveDataType} value
 * @return {!proto.type.SensitiveData} returns this
 */
proto.type.SensitiveData.prototype.setDataType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * A tuple of {field number, class constructor} for the extension
 * field named `sensitiveData`.
 * @type {!jspb.ExtensionFieldInfo<!proto.type.SensitiveData>}
 */
proto.type.sensitiveData = new jspb.ExtensionFieldInfo(
    50001,
    {sensitiveData: 0},
    proto.type.SensitiveData,
     /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ (
         proto.type.SensitiveData.toObject),
    0);

google_protobuf_descriptor_pb.FieldOptions.extensionsBinary[50001] = new jspb.ExtensionFieldBinaryInfo(
    proto.type.sensitiveData,
    jspb.BinaryReader.prototype.readMessage,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.type.SensitiveData.serializeBinaryToWriter,
    proto.type.SensitiveData.deserializeBinaryFromReader,
    false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
google_protobuf_descriptor_pb.FieldOptions.extensions[50001] = proto.type.sensitiveData;

goog.object.extend(exports, proto.type);
